import json5         from 'json5'                ;
import isPlainObject from 'lodash.isplainobject' ;
import { parse as parseUrl, format as formatUrl } from 'native-url'

export function uniqueArrayOfObjects(passedArray){
    const setOfStrings = new Set(passedArray.map(e => json5.stringify(e)));

    return Array.from(setOfStrings).map(e => json5.parse(e));
}

export function uniqueArray(passedArray){
    const setOfStrings = new Set(passedArray);

    return Array.from(setOfStrings);
}

export function uniqueArrayObjectsByKey(passedArray, key){
    const seen = new Set();

    return passedArray.filter(item => {
        const value = item[key];

        if (seen.has(value)) return false;

        seen.add(value);
        return true;
    });
}

export const falsyFilter = x => x && x !== 'undefined' && x !== 'null';

export function parseJson(dataString){
    try {
        if(isPlainObject(dataString))   return dataString;

        return json5.parse(dataString);
    }catch(e){
        return undefined;
    }
}

export const unLocales = ['en', 'ar', 'es', 'fr', 'ru', 'zh'];

export function debounce(fn, wait){
    let timer;
    return function(...args){
        if(timer) {
            clearTimeout(timer); // clear any pre-existing timer
        }
        const context = this; // get the current context
        timer = setTimeout(()=>{
            fn.apply(context, args); // call the function if time expires
        }, wait);
    }
}

export function randomArrayIndexTimeBased(total = 3){
    const minutes = new Date().getMinutes();

    for(let i = 0; i < total; i++)
        if(minutes <= ((60/total) * i+1)) return i;

    return 0
}

export const randomTime = randomArrayIndexTimeBased;

export  function getGbfUrl(identifier){
    const number = Number(identifier.replace('GBF-TARGET-', ''));

    return `https://www.cbd.int/gbf/targets/${number}`
}

export function hasSessionCookieClient(){
    if(process.server) return false;
    
    const cookies = document.cookie.split(';');

    for (let cookie of cookies) {
        const [key] = cookie.trim().split('=');

        if (!key.startsWith('SSESS')) continue;
        
        return key;
    }

    return null;
}
export function sortArrayOfObjectsByProp(a,b, prop, direction = 'asc'){
    const isAsc = direction === 'asc';

    if(a[prop] < b[prop]) return isAsc? 1 : -1; 
    if(a[prop] > b[prop]) return isAsc? -1 : 1; 

    return 0;
}

export const mapLocaleToDrupal = (locale) => {
    if (locale === 'zh') return 'zh-hans';
    if (locale === 'tl') return 'fil';

    return locale
}
  
export const mapLocaleFromDrupal = (locale) => {
    if (locale === 'zh-hans') return 'zh';
    if (locale === 'fil') return 'tl';

    return locale
}


export function truncateUrl(urlString, length) {
	if (typeof urlString !== 'string') {
		throw new TypeError('Expected input to be a string');
	}

	if (typeof length !== 'number') {
		throw new TypeError('Expected length to be a number');
	}

	if (urlString.length <= length) {
		return urlString;
	}

	const TRUNCATE_SYMBOL_LENGTH = 2;
	const parsed = parseUrl(urlString);
	let remainingLength = length - (urlString.length - parsed.path.length) - TRUNCATE_SYMBOL_LENGTH;
	const pathParts = parsed.path.split('/');
	const pathPartsReturnValue = [];
	let index = pathParts.length;

	while (index--) {
		const x = pathParts[index];

		if (remainingLength < x.length + 1) {
			pathPartsReturnValue.push('…');
			break;
		}

		pathPartsReturnValue.push(x);
		remainingLength -= x.length + 1;
	}

	parsed.pathname = pathPartsReturnValue.reverse().join('/');

	return formatUrl(parsed);
}

export async function $fetchRetry(url, options) {
    const MAX_NB_RETRY = 10;
    const RETRY_DELAY_MS = 2000;

    let retryLeft = MAX_NB_RETRY;
    while (retryLeft > 0){
        try {
            return await $fetch(url, options);
        }
        catch (err) { 
            await sleep(RETRY_DELAY_MS)
        }
        finally {
            retryLeft -= 1;
        }
    }
    throw new Error(`Too many retries`);
}

function sleep(delay=200){
    return new Promise((resolve) => setTimeout(resolve, delay));
}

// // ssr safe
export const randomizedArray = (yourArray) => seededShuffle(yourArray, getCurrentHourSeed());

export     function sortObj([x,a],[y,b]){
    const nameA = a.name.toUpperCase(); 
    const nameB = b.name.toUpperCase();

    if (nameA < nameB)  return -1;
    
    if (nameA > nameB)  return 1;

    return 0;
}

export function makeDrupalPathFromENtity(entity){
    if(!entity || typeof entity !== 'object') return undefined;

    const alias = getEntityAlias(entity);

    if(alias) return alias;

    const type = entity?.type || '';

    const taxonomyId = entity?.drupalInternalTid ?? entity?.drupal_internal__tid;
    if(type.startsWith('taxonomy_term--') || taxonomyId)
        return taxonomyId ? `/taxonomy/term/${taxonomyId}` : undefined;

    const nodeId = entity?.drupalInternalNid ?? entity?.drupal_internal__nid;
    if(type.startsWith('node--') || nodeId)
        return nodeId ? `/node/${nodeId}` : undefined;

    const mediaId = entity?.drupalInternalMid ?? entity?.drupal_internal__mid;
    if(type.startsWith('media--') || mediaId)
        return mediaId ? `/media/${mediaId}` : undefined;

    return undefined;
}

function getEntityAlias(entity){
    if(entity?.path?.alias) return entity.path.alias;

    if(entity?.aliases){
        const preferredLocales = uniqueArray([entity?.langcode, 'en', ...Object.keys(entity.aliases || {})].filter(Boolean));

        for(const locale of preferredLocales)
            if(entity.aliases[locale]) return entity.aliases[locale];

        const firstAlias = Object.values(entity.aliases).find(Boolean);
        if(firstAlias) return firstAlias;
    }

    return undefined;
}

function seededShuffle(array, seed) {
    // Simple seeded PRNG (Mulberry32)
    function mulberry32(a) {
        return function() {
            var t = a += 0x6D2B79F5;
            t = Math.imul(t ^ t >>> 15, t | 1);
            t ^= t + Math.imul(t ^ t >>> 7, t | 61);
            return ((t ^ t >>> 14) >>> 0) / 4294967296;
        }
    }
    const rng = mulberry32(seed);
    const arr = array.slice();
    for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(rng() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
}

function getCurrentHourSeed() {
    const now = new Date();
    // YYYYMMDDHH as integer
    return parseInt(
        now.getFullYear().toString() +
        String(now.getMonth() + 1).padStart(2, '0') +
        String(now.getDate()).padStart(2, '0') +
        String(now.getHours()).padStart(2, '0')
    );
}

